<template>
  <div>
    <a-card title="账户转账">
      <a-row :gutter="16">
        <a-col :span="4">
          <a-input-search v-model="searchForm.search" placeholder="名称, 备注,单号" allowClear @search="search" />
        </a-col>

        <a-col :span="3">
          <a-select v-model="searchForm.out_account" placeholder="选择转出账户" allowClear @change="search" style="width: 100%;">
            <a-select-option v-for="account in accountsItems" :key="account.id" :value="account.id">
              {{ account.name }}
            </a-select-option>
          </a-select>
        </a-col>

        <a-col :span="3">
          <a-select v-model="searchForm.in_account" placeholder="选择转入账户" allowClear @change="search" style="width: 100%;">
            <a-select-option v-for="account in accountsItems" :key="account.id" :value="account.id">
              {{ account.name }}
            </a-select-option>
          </a-select>
        </a-col>

        <a-col :span="4">
          <div>转账总金额：{{ total_transfer_amount.toFixed(2) }}</div>
        </a-col>

        <a-col :span="3">
          <div>手续费：{{ total_service_charge.toFixed(2) }}</div>
        </a-col>

        <a-col :span="4">
          <a-month-picker style="width: 100px;margin-right: 12px" valueFormat="YYYY-MM" :format="'YYYY-MM'"
            :defaultValue="defaultMonth" @change="onChangePicker" placeholder="选择月份" />
          <a-button type="primary" @click="onExport">导出</a-button>
        </a-col>

        <a-col :span="3">
          <a-button type="primary" icon="plus" @click="openFormModal(form)">新增转账单</a-button>
        </a-col>
      </a-row>

      <a-row style="margin-top: 12px" id="tableContainer">
        <a-table size="small" :columns="columns" :dataSource="items" rowKey="id" :loading="loading"
          :rowClassName="rowClassName" :scroll="{ x: 1500, y: 575 }" :pagination="pagination" @change="tableChange">
          <div slot="is_active" slot-scope="value">
            <a-tag :color="value ? 'green' : 'red'">{{
              value ? '激活' : '冻结'
            }}</a-tag>
          </div>
          <div slot="action" slot-scope="value, item">
            <a-button-group>
              <a-popconfirm title="确定作废吗?" @confirm="voidItem(item)">
                <a-button type="danger" size="small" :disabled="item.is_void">{{
                  item.is_void ? '已作废' : '作废'
                }}</a-button>
              </a-popconfirm>
            </a-button-group>
          </div>
        </a-table>
      </a-row>
    </a-card>

    <form-modal v-model="visible" :form="targetItem" :handlerItems="handlerItems" :accountsItems="accountsItems"
      @create="create" @update="update" />
  </div>
</template>

<script>
import { userOption, accountsOption } from '@/api/option';
import {
  accountTransferOrdersList,
  accountTransferOrdersVoid,
} from '@/api/finance';
import { saleExport } from "@/api/sale";
import { ChangePicker, exportExcel1 } from "@/utils/excel";

export default {
  name: 'Warehouse',
  components: {
    FormModal: () => import('./FormModal.vue'),
  },
  data() {
    return {
      monthFormat: 'YYYY-MM',
      columns: [
        {
          title: '序号',
          dataIndex: 'index',
          width: '80px',
          fixed: 'left',
          key: 'index',
          customRender: (value, item, index) => {
            return index + 1;
          },
        },
        {
          title: '转出账户',
          width: '150px',

          dataIndex: 'out_account_name',
        },
        {
          title: '转出时间',
          width: '150px',
          dataIndex: 'transfer_out_time',
          customRender: (val) => val ? val.replace('T', ' ').slice(0, 19) : '',
        },
        {
          title: '转入账户',
          width: '150px',
          dataIndex: 'in_account_name',
        },
        {
          title: '转入时间',
          width: '150px',
          dataIndex: 'transfer_in_time',
          customRender: (val) => val ? val.replace('T', ' ').slice(0, 19) : '',
        },
        {
          title: '转账金额',
          width: '150px',
          dataIndex: 'transfer_amount',
        },
        {
          title: '手续费金额',
          width: '100px',
          dataIndex: 'service_charge_amount',
        },
        {
          title: '手续费支付方',
          width: '150px',
          dataIndex: 'service_charge_payer_display',
        },
        {
          title: '经手人',
          width: '150px',
          dataIndex: 'handler_name',
        },
        {
          title: '录入时间',
          width: '150px',
          dataIndex: 'create_time',
        },
        {
          title: '备注',
          width: '250px',
          dataIndex: 'remark',
        },
        {
          title: '操作',
          width: '100px',
          dataIndex: 'action',
          fixed: 'right',
          scopedSlots: { customRender: 'action' },

        },
      ],
      searchForm: { search: '', out_account: undefined, in_account: undefined, start_time: '', end_time: '', page: 1, page_size: 50 },
      pagination: { current: 1, total: 0, pageSize: 50 }, // 生效的是这个
      loading: false,
      items: [],
      handlerItems: [],
      accountsItems: [],
      visible: false,
      targetItem: {},
      form: {},
      importLoading: false,
      total_transfer_amount: 0, // 添加转账金额总和
      total_service_charge: 0,  // 添加手续费总和
      defaultMonth: this.getLastMonth(), // 添加默认月份（上个月
    };
  },
  computed: {

  },
  methods: {
    toggleVisibility() {
      // 发送一个事件给父组件，要求它改变 visible 的值
      this.$emit('update:visible', !this.visible);
    },

    onChangePicker(a, b) {
      if (a == null) {
        this.searchForm.start_date = a;
        this.searchForm.end_date = a;
        this.search();
        return;
      }
      const { first_day1, last_day1 } = ChangePicker(a, b)
      this.searchForm.start_date = first_day1;
      this.searchForm.end_date = last_day1;
      this.search();
    },

    onExport() {
      import("../../../utils/xlsx.js").then((excel) => {
        //tHeader 为导出后的表头
        let tHeader = [], filterVal = [], list = []
        tHeader = ["转出账户", "转出时间", "转入账户", "转入时间", "转账金额", "手续费金额", "手续费支付方", "经手人", "发生日期", "备注"];
        filterVal = ["out_account_name", "transfer_out_time", "in_account_name", "transfer_in_time", "transfer_amount", "service_charge_amount", "service_charge_payer_display", "handler_name", "handle_time", "remark"];
        list = this.items
        list.reverse();
        const data = this.formatJson(filterVal, list);
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: `账户转账${this.getCurrentDate()}`,
          autoWidth: true,
          bookType: "xlsx",
        });
      });

    },
    getCurrentDate() {
      let today = new Date();
      let year = today.getFullYear();
      let month = (today.getMonth() + 1).toString().padStart(2, '0'); // 月份从0开始，需要+1，并且补0到两位数
      let day = today.getDate().toString().padStart(2, '0'); // 补0到两位数
      let formattedDate = `${year}${month}${day}`; // 拼接年月日
      return formattedDate;
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) =>
        filterVal.map((j) => {
          if (j === "timestamp") {
            return parseTime(v[j]);
          } else {
            return v[j];
          }
        })
      );
    },

    //设置某行tr背景色
    rowClassName(record, index) {
      if (record.is_void === true) return 'light-yellow';
      if (record.is_active === false) return 'light-gray';
    },
    // 获取上个月的方法
    getLastMonth() {
      const date = new Date();
      date.setMonth(date.getMonth() - 1);
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      return `${year}-${month}`;
    },

    // 修改 initialize 方法
    initialize() {
      // 设置初始搜索条件为上个月
      const { first_day1, last_day1 } = ChangePicker(this.defaultMonth);
      this.searchForm.start_date = first_day1;
      this.searchForm.end_date = last_day1;

      // 加载账户列表
      accountsOption({ page_size: 999999, is_active: true }).then(data => {
        this.accountsItems = data.results;
      });

      this.list();
    },
    list() {
      this.loading = true;
      accountTransferOrdersList(this.searchForm)
        .then(data => {
          this.pagination.total = data.count;
          this.items = data.results;

          this.exportItems = []
          this.total_transfer_amount = 0; // 重置转账金额总和
          this.total_service_charge = 0;  // 重置手续费总和

          this.items.forEach(item => {
            const obj = item
            const transferAmount = parseFloat(item.transfer_amount)
            const serviceCharge = parseFloat(item.service_charge_amount)

            obj.transfer_amount = transferAmount
            obj.service_charge_amount = serviceCharge // 手续费

            // 只有未作废的记录才计入总和
            if (!item.is_void) {
              this.total_transfer_amount += transferAmount;
              this.total_service_charge += serviceCharge;
            }

            this.exportItems.push(obj)
          })
        })
        .finally(() => {
          this.loading = false;
        });
    },
    tableChange(pagination, filters, sorter) {
      this.searchForm.page = pagination.current;
      this.pagination.current = pagination.current;
      this.searchForm.ordering = `${sorter.order === 'descend' ? '-' : ''}${sorter.field
        }`;
      this.list();
    },
    create(item) {
      // this.items.splice(0, 0, item);
      this.list();
    },
    update(item) {
      this.items.splice(
        this.items.findIndex(i => i.id === item.id),
        1,
        item
      );
    },
    search() {
      this.searchForm.page = 1;
      this.pagination.current = 1;
      this.list();
    },
    openFormModal(item) {
      userOption({ page_size: 999999, is_active: true }).then(data => {
        this.handlerItems = data.results;
      });
      accountsOption({ page_size: 999999, is_active: true }).then(data => {
        this.accountsItems = data.results;
      });
      this.targetItem = JSON.parse(JSON.stringify(item));
      this.visible = true;
    },
    voidItem(item) {
      accountTransferOrdersVoid({ id: item.id }).then(() => {
        this.$message.success('作废成功');
        this.list();
      }).catch(() => {
      });
    },
  },

  mounted() {
    this.initialize();
  },
};
</script>
<style lang="css" scoped>
/deep/.ant-table-tbody .light-yellow {
  background-color: #f5f4f3 !important;
}

/deep/.ant-table-tbody .second {
  background-color: #071641 !important;
}
</style>
